"use strict";

module.exports = {
    JET_NO_REPLY: "\"Signiant Jet\" <no-reply@signiant.com>"
};